import { AppUser } from 'store/ducks/users/types';

/*
 * Action Types
 */
export enum AppUserMergeTypes {
  LIST_APP_USER_MERGE_REQUEST = '@appUserMerge/LIST_APP_USER_MERGE_REQUEST',
  LIST_APP_USER_MERGE_SUCCESS = '@appUserMerge/LIST_APP_USER_MERGE_SUCCESS',
  LIST_APP_USER_MERGE_FAILURE = '@appUserMerge/GET_AUDIO_FAILURE',

  UPDATE_APP_USER_MERGE_REQUEST = '@appUserMerge/UPDATE_APP_USER_MERGE_REQUEST',
  UPDATE_APP_USER_MERGE_SUCCESS = '@appUserMerge/UPDATE_APP_USER_MERGE_SUCCESS',
  UPDATE_APP_USER_MERGE_FAILURE = '@appUserMerge/UPDATE_APP_USER_MERGE_FAILURE',

  APP_USER_MERGE_CURRENT_CARD = '@appUserMerge/APP_USER_MERGE_CURRENT_CARD',
}

/* Data Types */
export interface AppUserMergeInterface {
  id: string;
  status: number;
  oldSecondaryUserId: string | null;
  selfiePhoto: string;
  documentPhoto: string;
  bothPhoto: string;
  primaryUserId: string;
  secondaryUserId: string;
  supervisorId: string | null;
  description: string | null;
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
  primaryUser: AppUser;
  secondaryUser: AppUser | null;
}

/*
 * State type
 */
export interface AppUserMergeState {
  readonly appUserMergeList: Array<AppUserMergeInterface>;
  readonly cardIndex: number;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
